import IAmount from "./IAmount";
import ILiabilityBase from "@/module/main/dto/ILiabilityBase";
import ILiabilityFinancing from "@/module/main/dto/ILiabilityFinancing";

export default class LiabilityBase implements ILiabilityBase {
    constructor(public amount?: IAmount, public financing?: ILiabilityFinancing) {}
}
